import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { Task } from 'app/models';
import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const mstUrl = contractId => `${environment.apiUrl}/mst/${contractId}`;
const mstExportUrl = (contractId, soapEnvelope) =>
  `${environment.apiUrl}/mst/export/${contractId}?soapEnvelope=${soapEnvelope}`;
const mstExportFcdUrl = fcdProviderId => `${environment.apiUrl}/mst/export/fcd/${fcdProviderId}`;
const taskStatusUrl = contractId => `${environment.apiUrl}/tasks/contract/${contractId}`;

@Injectable()
export class MstService {
  constructor(private readonly httpService: HttpService) {}

  getImportTask(contractId: number): Observable<Task> {
    return this.httpService.get(taskStatusUrl(contractId));
  }

  importMst(contractId: number, mstFile: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', mstFile);

    return this.httpService.postFileWithProgress(mstUrl(contractId), formData);
  }

  downloadMst(contractId: number, soapEnvelope: boolean): Observable<any> {
    return this.httpService.post(mstExportUrl(contractId, soapEnvelope), null);
  }

  downloadMstFcd(fcdProviderId: number): Observable<any> {
    return this.httpService.post(mstExportFcdUrl(fcdProviderId), null);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/mst.service.ts